import moment from 'moment';

export const formatContractDate = (date) => date ? moment(new Date(date)).format('YYYY-MM-DD hh:mm') : null;
